import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLanguage } from '../contexts/LanguageContext';

// Comprehensive SEO data for all languages
const SEO_DATA = {
  home: {
    en: {
      title: 'Penlab Peptide Pens, Premium Research Peptides Worldwide',
      description: 'Penlab Peptide, global supplier of peptide pens and premium research peptides. 143+ products including BPC-157, semaglutide, tirzepatide, SARMs, bioregulators, NAD+, shipped worldwide to licensed laboratories.',
      keywords: 'peptide pen, peptide pens, penlab peptide, research peptides worldwide, premium research peptides, high purity peptides, SARMs, bioregulators, NAD+, BPC-157, GLP-1, semaglutide, tirzepatide, global peptide supplier, laboratory peptides'
    },
    es: {
      title: 'Penlab Peptide, Peptidos España, Comprar Online Mundial',
      description: 'Penlab Peptide, proveedor mundial de péptidos de investigación premium y peptide pens. Compra peptidos en España con envío desde Madrid. Más de 143 productos: BPC-157, semaglutida, tirzepatida, SARMs, biorreguladores, NAD+.',
      keywords: 'peptide pen, peptide pens, penlab peptide, peptidos España, comprar peptidos, peptide comprar, peptid comprar en linea, pen peptide spain, péptidos investigación, péptidos premium, BPC-157, semaglutida, SARMs, biorreguladores, NAD+, proveedor mundial péptidos'
    },
    ru: {
      title: 'Penlab Peptide, Премиум Пептиды для Исследований',
      description: 'Мировой поставщик премиальных исследовательских пептидов и лабораторных материалов высокой чистоты. Более 143 продуктов, SARMs, биорегуляторы, NAD+, BPC-157, доставка лабораториям и научным учреждениям по всему миру.',
      keywords: 'пептиды для исследований по всему миру, премиум пептиды, пептиды высокой чистоты, SARMs, биорегуляторы, NAD+, BPC-157, GLP-1, мировой поставщик пептидов, лабораторные пептиды'
    }
  },
  products: {
    en: {
      title: 'Research Peptides Catalog | 143+ Products Worldwide | Penlab Peptide',
      description: 'Browse our complete catalog of 143+ research peptides shipped worldwide. SARMs, bioregulators, NAD+ boosters, BPC-157, growth peptides and more. High-purity pen, vial and nasal spray formats.',
      keywords: 'peptide catalog, research peptides worldwide, buy peptides online, SARMs products, bioregulator peptides, NAD+ supplements, BPC-157 peptide, global peptide catalog'
    },
    es: {
      title: 'Catálogo de Péptidos de Investigación | 143+ Productos Mundiales | Penlab Peptide',
      description: 'Explore nuestro catálogo completo de más de 143 péptidos de investigación con envío mundial. SARMs, biorreguladores, potenciadores NAD+, BPC-157 y más. Formatos pluma, vial y spray nasal.',
      keywords: 'catálogo péptidos mundial, péptidos de investigación internacionales, comprar péptidos online, productos SARMs, péptidos biorreguladores, suplementos NAD+'
    },
    ru: {
      title: 'Каталог Исследовательских Пептидов | 143+ Продуктов по Всему Миру | Penlab Peptide',
      description: 'Полный каталог из более чем 143 исследовательских пептидов с доставкой по всему миру. SARMs, биорегуляторы, бустеры NAD+, BPC-157 и другие. Форматы: ручка, флакон, назальный спрей.',
      keywords: 'мировой каталог пептидов, исследовательские пептиды онлайн, купить пептиды, продукты SARMs, пептиды биорегуляторы'
    },
    de: {
      title: 'Forschungspeptide-Katalog | 143+ Produkte weltweit | Penlab Peptide',
      description: 'Entdecken Sie unseren vollständigen Katalog mit über 143 Forschungspeptiden, weltweit versendet. SARMs, Bioregulatoren, NAD+-Booster, BPC-157, Wachstumspeptide und mehr. Hochreine Pen-, Vial- und Nasenspray-Formate.',
      keywords: 'Peptid-Katalog, Forschungspeptide weltweit, Peptide kaufen, SARMs Produkte, Bioregulator-Peptide, NAD+ Präparate, BPC-157 Peptid, globaler Peptid-Katalog'
    },
    fr: {
      title: 'Catalogue de Peptides de Recherche | 143+ Produits dans le Monde | Penlab Peptide',
      description: 'Parcourez notre catalogue complet de plus de 143 peptides de recherche expédiés dans le monde entier. SARMs, biorégulateurs, boosters NAD+, BPC-157, peptides de croissance et plus. Formats stylo, flacon et spray nasal haute pureté.',
      keywords: 'catalogue peptides, peptides de recherche mondial, acheter peptides en ligne, produits SARMs, peptides biorégulateurs, suppléments NAD+'
    },
    it: {
      title: 'Catalogo Peptidi di Ricerca | 143+ Prodotti nel Mondo | Penlab Peptide',
      description: 'Sfoglia il nostro catalogo completo di oltre 143 peptidi di ricerca con spedizione mondiale. SARMs, bioregolatori, booster NAD+, BPC-157, peptidi della crescita e altro. Formati penna, fiala e spray nasale ad alta purezza.',
      keywords: 'catalogo peptidi, peptidi di ricerca mondiale, acquistare peptidi online, prodotti SARMs, peptidi bioregolatori, integratori NAD+'
    },
    pl: {
      title: 'Katalog Peptydów Badawczych | 143+ Produktów na Świecie | Penlab Peptide',
      description: 'Przeglądaj nasz pełny katalog ponad 143 peptydów badawczych z wysyłką na cały świat. SARMs, bioregulatory, boostery NAD+, BPC-157, peptydy wzrostu i więcej. Formaty pen, fiolka i spray do nosa o wysokiej czystości.',
      keywords: 'katalog peptydów, peptydy badawcze świat, kup peptydy online, produkty SARMs, peptydy bioregulatory, suplementy NAD+'
    },
    nl: {
      title: 'Onderzoekspeptiden Catalogus | 143+ Producten Wereldwijd | Penlab Peptide',
      description: 'Bekijk onze complete catalogus van meer dan 143 onderzoekspeptiden met wereldwijde verzending. SARMs, bioregulatoren, NAD+ boosters, BPC-157, groeipeptiden en meer. Hoogzuivere pen-, vial- en neusspray-formaten.',
      keywords: 'peptide catalogus, onderzoekspeptiden wereldwijd, peptiden kopen online, SARMs producten, bioregulator peptiden, NAD+ supplementen'
    },
    pt: {
      title: 'Catálogo de Peptídeos de Pesquisa | 143+ Produtos no Mundo | Penlab Peptide',
      description: 'Explore nosso catálogo completo com mais de 143 peptídeos de pesquisa com envio mundial. SARMs, biorreguladores, boosters de NAD+, BPC-157, peptídeos de crescimento e mais. Formatos caneta, frasco e spray nasal de alta pureza.',
      keywords: 'catálogo peptídeos, peptídeos de pesquisa mundial, comprar peptídeos online, produtos SARMs, peptídeos biorreguladores, suplementos NAD+'
    }
  },
  about: {
    en: {
      title: 'About Penlab Peptide | Global Research Peptide Supplier',
      description: 'Penlab Peptide is a worldwide supplier of research peptides with regional hubs in Madrid, London, Mexico City, Miami, Dubai, and Singapore. 99%+ purity standards for licensed laboratories.',
      keywords: 'about Penlab Peptide, global peptide company, research peptide supplier, international peptide company, 99% purity peptides, worldwide peptide shipping'
    },
    es: {
      title: 'Sobre Penlab Peptide | Proveedor Mundial de Péptidos de Investigación',
      description: 'Penlab Peptide es proveedor mundial de péptidos de investigación con centros regionales en Madrid, Londres, Ciudad de México, Miami, Dubái y Singapur. Estándares de pureza 99%+.',
      keywords: 'sobre Penlab Peptide, empresa mundial péptidos, proveedor internacional péptidos, envío mundial péptidos'
    },
    ru: {
      title: 'О Penlab Peptide | Мировой Поставщик Исследовательских Пептидов',
      description: 'Penlab Peptide, мировой поставщик исследовательских пептидов с региональными хабами в Мадриде, Лондоне, Мехико, Майами, Дубае и Сингапуре. Стандарты чистоты 99%+.',
      keywords: 'о Penlab Peptide, мировой поставщик пептидов, международная пептидная компания, глобальная доставка пептидов'
    }
  },
  blog: {
    en: {
      title: 'Peptide Research Blog | Science & News | PenLab Peptide',
      description: 'Latest peptide research news, scientific articles on SARMs, NAD+, BPC-157, bioregulators and more. Expert insights into peptide science and developments.',
      keywords: 'peptide blog, peptide research news, SARMs research, NAD+ science, BPC-157 studies, peptide articles, scientific peptide blog'
    },
    es: {
      title: 'Blog de Investigación de Péptidos | Ciencia | PenLab Peptide',
      description: 'Últimas noticias de investigación de péptidos, artículos científicos sobre SARMs, NAD+, BPC-157, biorreguladores y más. Perspectivas expertas sobre la ciencia de péptidos.',
      keywords: 'blog péptidos, noticias investigación péptidos, investigación SARMs, ciencia NAD+, estudios BPC-157, artículos péptidos'
    },
    ru: {
      title: 'Блог Исследований Пептидов | Наука | PenLab Peptide',
      description: 'Последние новости исследований пептидов, научные статьи о SARMs, NAD+, BPC-157, биорегуляторах и многом другом. Экспертные взгляды на науку о пептидах.',
      keywords: 'блог пептиды, новости исследований пептидов, исследования SARMs, наука NAD+, статьи о пептидах'
    }
  },
  contact: {
    en: {
      title: 'Contact PenLab Peptide | Research Peptide Inquiries',
      description: 'Contact PenLab Peptide for research peptide inquiries, wholesale orders, and scientific collaboration. Professional support for licensed laboratories and institutions.',
      keywords: 'contact PenLab Peptide, peptide inquiries, wholesale peptides, laboratory orders, research collaboration'
    },
    es: {
      title: 'Contacto PenLab Peptide | Consultas de Péptidos',
      description: 'Contacte PenLab Peptide para consultas sobre péptidos de investigación, pedidos mayoristas y colaboración científica.',
      keywords: 'contacto PenLab Peptide, consultas péptidos, péptidos mayorista, pedidos laboratorio'
    },
    ru: {
      title: 'Контакты PenLab Peptide | Запросы на Пептиды',
      description: 'Свяжитесь с PenLab Peptide для запросов на исследовательские пептиды, оптовых заказов и научного сотрудничества.',
      keywords: 'контакты PenLab Peptide, запросы пептиды, оптовые пептиды, заказы для лабораторий'
    }
  },
  affiliate: {
    en: {
      title: 'Affiliate Program | Earn 10-20% Commission | PenLab Peptide',
      description: 'Join PenLab Peptide affiliate program. Earn 10-20% commission on research peptide sales. Perfect for scientists, researchers, and industry professionals.',
      keywords: 'peptide affiliate program, research peptide commission, peptide partnership, earn with peptides, scientific affiliate'
    },
    es: {
      title: 'Programa de Afiliados | Gane 10-20% Comisión | PenLab Peptide',
      description: 'Únase al programa de afiliados de PenLab Peptide. Gane 10-20% de comisión en ventas de péptidos de investigación.',
      keywords: 'programa afiliados péptidos, comisión péptidos investigación, asociación péptidos'
    },
    ru: {
      title: 'Партнерская Программа | 10-20% Комиссии | PenLab Peptide',
      description: 'Присоединяйтесь к партнерской программе PenLab Peptide. Зарабатывайте 10-20% комиссии с продаж исследовательских пептидов.',
      keywords: 'партнерская программа пептиды, комиссия пептиды, партнерство пептиды'
    }
  }
};

/**
 * SEO Component for dynamic meta tags based on page and language
 */
const SEOHead = ({ page = 'home', customTitle, customDescription, customKeywords, productName, productDescription, imageUrl }) => {
  const { currentLanguage } = useLanguage();
  
  const seoData = SEO_DATA[page] || SEO_DATA.home;
  const langData = seoData[currentLanguage] || seoData.en;
  
  const title = customTitle || langData.title;
  const description = customDescription || langData.description;
  const keywords = customKeywords || langData.keywords;
  
  // For product pages, create enhanced SEO with locale-specific suffix.
  // CRITICAL: prior implementation only branched on es/ru → all other 6
  // locales got "Research Peptides" (EN) appended to the <title>, which
  // contributed to Google's "Duplicate canonical: EN chosen" merge for the
  // 910 translated product URLs. Fix: 9-language suffix dict.
  const PRODUCT_TITLE_SUFFIX = {
    en: 'Research Peptides',
    es: 'Péptidos de Investigación',
    ru: 'Исследовательские Пептиды',
    de: 'Forschungspeptide',
    fr: 'Peptides de Recherche',
    it: 'Peptidi di Ricerca',
    pl: 'Peptydy Badawcze',
    nl: 'Onderzoekspeptiden',
    pt: 'Peptídeos de Pesquisa',
  };
  const finalTitle = productName
    ? `${productName} | PenLab Peptide | ${PRODUCT_TITLE_SUFFIX[currentLanguage] || PRODUCT_TITLE_SUFFIX.en}`
    : title;
    
  const finalDescription = productDescription || description;
  
  const defaultImage = 'https://customer-assets.emergentagent.com/job_6d651465-2998-4001-9651-0b3a9db3fd32/artifacts/nxdjavof_WhatsApp%20Image%202026-02-07%20at%2013.29.48.jpeg';
  const ogImage = imageUrl || defaultImage;

  // Imperative fallback: guarantees <title>, <meta name=description>, and <html lang>
  // are updated even if react-helmet-async fails to flush (e.g., provider not wrapping
  // this subtree, SSR mismatch, etc.). Critical for multi-language SEO.
  useEffect(() => {
    try {
      document.title = finalTitle;
      // html lang must match the actual active language across all 9 supported locales.
      const SUPPORTED_LANGS = ['en','es','ru','de','fr','it','pl','nl','pt'];
      const activeLang = SUPPORTED_LANGS.includes(currentLanguage) ? currentLanguage : 'en';
      document.documentElement.lang = activeLang;
      const setMeta = (selector, value) => {
        const el = document.querySelector(selector);
        if (el && value) el.setAttribute('content', value);
      };
      setMeta('meta[name="description"]', finalDescription);
      setMeta('meta[name="title"]', finalTitle);
      setMeta('meta[name="keywords"]', keywords);
      setMeta('meta[property="og:title"]', finalTitle);
      setMeta('meta[property="og:description"]', finalDescription);
      setMeta('meta[property="og:image"]', ogImage);
      const OG_LOCALE = {en:'en_US', es:'es_ES', ru:'ru_RU', de:'de_DE', fr:'fr_FR', it:'it_IT', pl:'pl_PL', nl:'nl_NL', pt:'pt_BR'};
      setMeta('meta[property="og:locale"]', OG_LOCALE[activeLang] || 'en_US');
      setMeta('meta[property="twitter:title"]', finalTitle);
      setMeta('meta[property="twitter:description"]', finalDescription);
      setMeta('meta[property="twitter:image"]', ogImage);

      // ---- SERP-thumbnail signals (iter-52, applies to all pages but most
      // valuable on /product/* because Google's image-rich SERPs lean heavily
      // on these tags for the product thumbnail. Three signals:
      //   1) <meta name="image">, legacy but still indexed by Google
      //   2) <meta itemprop="image">, microdata, used by Schema.org pickers
      //   3) <link rel="image_src">, used by Facebook/LinkedIn unfurlers AND
      //      Google's "Image Search" preview when og:image is missing.
      // Imperative because Helmet drops some <link> children on locale changes
      // (same root cause as the iter-51 BreadcrumbList drop). Idempotent: each
      // tag is tagged with data-plp-image=1 and replaced on every effect run. */
      try {
        document.querySelectorAll('[data-plp-image="1"]').forEach((el) => el.remove());
        const head = document.head || document.getElementsByTagName('head')[0];
        const tags = [
          ['meta', { name: 'image', content: ogImage }],
          ['meta', { itemprop: 'image', content: ogImage }],
          ['link', { rel: 'image_src', href: ogImage }],
        ];
        for (const [tag, attrs] of tags) {
          const el = document.createElement(tag);
          for (const [k, v] of Object.entries(attrs)) el.setAttribute(k, v);
          el.setAttribute('data-plp-image', '1');
          head.appendChild(el);
        }
      } catch (_) { /* no-op */ }

      // ---- Canonical & hreflang (imperative, Helmet is unreliable here) ----
      // Build base/canonical from current pathname stripped of any /:lang/ prefix.
      const path = window.location.pathname || '/';
      const seg = path.split('/')[1];
      const stripped = SUPPORTED_LANGS.includes(seg)
        ? (path.replace(`/${seg}`, '') || '/')
        : path;
      const tail = stripped === '/' ? '' : stripped;
      const canonical = `https://penlabpeptide.com/${activeLang}${tail}`;

      // Upsert canonical
      let canonEl = document.querySelector('link[rel="canonical"]');
      if (!canonEl) {
        canonEl = document.createElement('link');
        canonEl.setAttribute('rel', 'canonical');
        document.head.appendChild(canonEl);
      }
      canonEl.setAttribute('href', canonical);

      // Replace ALL existing hreflang links with the 9-lang + x-default block.
      document.querySelectorAll('link[rel="alternate"][hreflang]').forEach((el) => el.remove());
      SUPPORTED_LANGS.forEach((lc) => {
        const link = document.createElement('link');
        link.setAttribute('rel', 'alternate');
        link.setAttribute('hreflang', lc);
        link.setAttribute('href', `https://penlabpeptide.com/${lc}${tail}`);
        document.head.appendChild(link);
      });
      const xd = document.createElement('link');
      xd.setAttribute('rel', 'alternate');
      xd.setAttribute('hreflang', 'x-default');
      xd.setAttribute('href', `https://penlabpeptide.com${stripped}`);
      document.head.appendChild(xd);

      // ---- BreadcrumbList JSON-LD (imperative, Helmet drops some script
      // children silently on locale switch, observed in iter-51). Idempotent:
      // remove any prior breadcrumb script tagged with data-plp-breadcrumb=1
      // and re-add. Locale-aware labels for all 9 supported languages so the
      // breadcrumb rich result resolves to the SAME URL Googlebot canonicals.
      try {
        const HOME_LABELS = {
          en: 'Home', es: 'Inicio', ru: 'Главная', de: 'Startseite',
          fr: 'Accueil', it: 'Home', pl: 'Strona główna',
          nl: 'Home', pt: 'Início',
        };
        const PRODUCTS_LABELS = {
          en: 'Products', es: 'Productos', ru: 'Продукты', de: 'Produkte',
          fr: 'Produits', it: 'Prodotti', pl: 'Produkty',
          nl: 'Producten', pt: 'Produtos',
        };
        const BLOG_LABELS = {
          en: 'Blog', es: 'Blog', ru: 'Блог', de: 'Blog',
          fr: 'Blog', it: 'Blog', pl: 'Blog', nl: 'Blog', pt: 'Blog',
        };
        const ABOUT_LABELS = {
          en: 'About', es: 'Sobre Nosotros', ru: 'О Нас', de: 'Über uns',
          fr: 'À propos', it: 'Chi siamo', pl: 'O nas',
          nl: 'Over ons', pt: 'Sobre nós',
        };
        const items = [{
          '@type': 'ListItem',
          position: 1,
          name: HOME_LABELS[activeLang] || 'Home',
          item: `https://penlabpeptide.com/${activeLang}`,
        }];
        if (page === 'products') {
          items.push({
            '@type': 'ListItem',
            position: 2,
            name: PRODUCTS_LABELS[activeLang] || 'Products',
            item: `https://penlabpeptide.com/${activeLang}/products`,
          });
        } else if (page === 'blog') {
          items.push({
            '@type': 'ListItem',
            position: 2,
            name: BLOG_LABELS[activeLang] || 'Blog',
            item: `https://penlabpeptide.com/${activeLang}/blog`,
          });
        } else if (page === 'about') {
          items.push({
            '@type': 'ListItem',
            position: 2,
            name: ABOUT_LABELS[activeLang] || 'About',
            item: `https://penlabpeptide.com/${activeLang}/about`,
          });
        }
        // Product detail page → 3-level breadcrumb (home > products > name).
        if (productName) {
          if (items.length === 1) {
            items.push({
              '@type': 'ListItem',
              position: 2,
              name: PRODUCTS_LABELS[activeLang] || 'Products',
              item: `https://penlabpeptide.com/${activeLang}/products`,
            });
          }
          items.push({
            '@type': 'ListItem',
            position: items.length + 1,
            name: productName,
            item: canonical,
          });
        }
        document.querySelectorAll('script[data-plp-breadcrumb="1"]').forEach((el) => el.remove());
        const bc = document.createElement('script');
        bc.setAttribute('type', 'application/ld+json');
        bc.setAttribute('data-plp-breadcrumb', '1');
        bc.textContent = JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: items,
        });
        document.head.appendChild(bc);
      } catch (_) { /* no-op */ }
    } catch (_) {
      // no-op: defensive, never break render over head updates
    }
  }, [finalTitle, finalDescription, keywords, ogImage, currentLanguage, page, productName]);

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{finalTitle}</title>
      <meta name="title" content={finalTitle} />
      <meta name="description" content={finalDescription} />
      <meta name="keywords" content={keywords} />
      
      {/* Language, 9-language map (matches the useEffect imperative
          override on line 142-143). Prior implementation only branched on
          es/ru, leaving DE/FR/IT/PL/NL/PT with <html lang="en"> on initial
          paint, directly contributing to the GSC "Duplicate canonical:
          Google chose English" wave on 910 translated product URLs. */}
      <html lang={({ en:'en', es:'es', ru:'ru', de:'de', fr:'fr', it:'it', pl:'pl', nl:'nl', pt:'pt' }[currentLanguage]) || 'en'} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={productName ? 'product' : 'website'} />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content={({ en:'en_US', es:'es_ES', ru:'ru_RU', de:'de_DE', fr:'fr_FR', it:'it_IT', pl:'pl_PL', nl:'nl_NL', pt:'pt_BR' }[currentLanguage]) || 'en_US'} />
      <meta property="og:site_name" content="PenLab Peptide" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:title" content={finalTitle} />
      <meta property="twitter:description" content={finalDescription} />
      <meta property="twitter:image" content={ogImage} />
      
      {/* Additional SEO Meta */}
      <meta name="author" content="Penlab Peptide" />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1" />
      <meta name="googlebot" content="index, follow" />
      {/* Canonical + hreflang are managed IMPERATIVELY by the useEffect
          above (lines 195-216). Emitting them again here as JSX caused
          Helmet to add a second set on every mount, Semrush flagged
          11 URLs as "Hreflang conflicts within page source code" in the
          iter-44 audit. Single source of truth = the useEffect block. */}

      {/* Organization schema, ONLY on the home page (avoids duplication with head-level JSON-LD) */}
      {page === 'home' && (
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Penlab Peptide",
            "alternateName": ["PenLab Peptide", "Pen Lab Peptide"],
            "url": "https://penlabpeptide.com",
            "logo": "https://penlabpeptide.com/logo192.png",
            "description": finalDescription,
            "contactPoint": [{
              "@type": "ContactPoint",
              "email": "info@penlabpeptide.com",
              "contactType": "customer service",
              "availableLanguage": ["English", "Spanish", "Russian", "German", "French", "Italian", "Polish", "Dutch", "Portuguese"],
              "areaServed": "Worldwide"
            }],
            "location": [
              { "@type": "Place", "name": "Madrid Hub", "address": { "@type": "PostalAddress", "addressLocality": "Madrid", "addressCountry": "ES" } },
              { "@type": "Place", "name": "London Hub", "address": { "@type": "PostalAddress", "addressLocality": "London", "addressCountry": "GB" } },
              { "@type": "Place", "name": "Mexico City Hub", "address": { "@type": "PostalAddress", "addressLocality": "Mexico City", "addressCountry": "MX" } },
              { "@type": "Place", "name": "Miami Hub", "address": { "@type": "PostalAddress", "addressLocality": "Miami", "addressCountry": "US" } },
              { "@type": "Place", "name": "Dubai Hub", "address": { "@type": "PostalAddress", "addressLocality": "Dubai", "addressCountry": "AE" } },
              { "@type": "Place", "name": "Singapore Hub", "address": { "@type": "PostalAddress", "addressLocality": "Singapore", "addressCountry": "SG" } }
            ],
            "areaServed": [
              "United States", "United Kingdom", "Germany", "France", "Italy", "Poland",
              "Netherlands", "Spain", "Canada", "Australia", "Mexico", "Brazil",
              "Russia", "United Arab Emirates", "Singapore"
            ].map(c => ({ "@type": "Country", "name": c })),
            // Pillar 2 of B2B AI-search strategy: MedicalAudience tells
            // ChatGPT/Perplexity/Claude/AI Overviews this site serves
            // licensed clinical + research buyers (not consumers). Moves
            // Penlab above DTC supplement vendors in AI-citation ranking
            // for B2B-clinic procurement queries.
            "audience": [
              { "@type": "MedicalAudience", "audienceType": "Clinician" },
              { "@type": "MedicalAudience", "audienceType": "Researcher" },
              { "@type": "BusinessAudience", "audienceType": "Medical Clinic" },
              { "@type": "BusinessAudience", "audienceType": "Research Laboratory" },
              { "@type": "BusinessAudience", "audienceType": "Contract Research Organization" },
              { "@type": "BusinessAudience", "audienceType": "Pharmaceutical Company" }
            ],
            // Tells the AI-search reranker this is a B2B vendor offering
            // bulk procurement, directly relevant for queries like
            // "where do clinics buy peptides in bulk?".
            "knowsAbout": [
              "Research peptides", "Bulk B2B procurement", "Certificate of Analysis",
              "HPLC purity testing", "Cold-chain logistics", "Research-use-only compliance"
            ],
            "hasOfferCatalog": {
              "@type": "OfferCatalog",
              "name": "Bulk Procurement Tiers",
              "url": "https://penlabpeptide.com/bulk"
            }
          })}
        </script>
      )}
      
      {/* Product-specific schema intentionally NOT emitted here. The single
          authoritative Product JSON-LD lives in ProductPage.js so we don't
          ship two competing Product blobs on the same page (Google rejects
          rich-result eligibility while a conflict exists). Removed in
          iter-42 as part of the GMC-grade structured-data cleanup. */}
      
      {/* Breadcrumb Schema is injected imperatively in the useEffect above
          (lines ~190-260) because react-helmet-async sporadically drops
          <script type="application/ld+json"> children during locale
          switches, observed in iter-51 testing where 3 of 3 BreadcrumbList
          tags failed to appear in the DOM after route changes. The
          imperative injection writes a single tag marked with
          data-plp-breadcrumb=1 and replaces it on every effect re-run. */}
    </Helmet>
  );
};

export default SEOHead;
export { SEO_DATA };
